document.addEventListener('initProductDescriptionSpoiler', function (event) {
    const spoiler = event.target;

    if (spoiler) {
        const spoilerIn = spoiler.querySelector('.product-description-spoiler-in');
        const spoilerToggleBtn = spoiler.parentElement.querySelector('.product-description-spoiler-toggle-btn');

        const spoilerMaxHeight = parseInt(spoiler.dataset.height) || 168;
        const spoilerScrollTarget = spoiler.dataset.target;
        const spoilerScrollOnlyMobile = spoiler.dataset.scrollOnlyMobile;

        window.addEventListener('resize', function () {
            if (spoilerIn && spoilerIn.offsetHeight > spoilerMaxHeight) {
                spoiler.classList.add('enabled');
            } else {
                spoiler.classList.remove('enabled');
            }
        }, {passive: true});

        if (spoilerToggleBtn) {
            spoilerToggleBtn.addEventListener('click', function () {
                spoiler.classList.toggle('show');
                spoilerToggleBtn.classList.toggle('active');

                if (!spoilerToggleBtn.classList.contains('active')) {
                    if (spoilerScrollOnlyMobile) {
                        if (window.matchMedia('(max-width: 767px)').matches) {
                            spoiler.closest(spoilerScrollTarget)?.scrollIntoView({behavior: 'smooth'});
                        }
                    } else {
                        spoiler.closest(spoilerScrollTarget)?.scrollIntoView({behavior: 'smooth'});
                    }
                }
            });
        }

        window.dispatchEvent(new Event('resize'));

        spoiler.classList.add('initialized');
    }
});
